module.exports = __webpack_public_path__ + "img/food2.235a8a7c.png";